import {useNavigate} from "react-router-dom";
import {useSiren} from "../SirenContext";
import {useCallback} from "react";

export function useNavigateWithClientID() {
    const navigate = useNavigate();
    const {clientID} = useSiren()

    const navigateWithClientIDPath = useCallback((path: string) => {
        const url = new URL(path, `${window.location.protocol}//${window.location.host}`)
        if (clientID) {
            url.searchParams.set("clientID", clientID)
        }
        return `${url.pathname}?${url.searchParams.toString()}`
    }, [navigate, clientID])


    const navigateWithClientID = useCallback((path: string) => {

        navigate(navigateWithClientIDPath(path))
    }, [navigate, clientID])



    return {navigateWithClientID, navigateWithClientIDPath};


}